import React from 'react';
import DragLayer from 'react-dnd/lib/DragLayer';
import { View } from '@instructure/ui-view';
import { CELL_HEIGHT, COLUMN_WIDTH } from "../../../../util/gradebook/constants.js";
var getItemStyles = function getItemStyles(currentOffset) {
  if (!currentOffset) {
    return {
      display: 'none'
    };
  }
  var x = currentOffset.x,
    y = currentOffset.y;
  var transform = "translate(".concat(x, "px, ").concat(y, "px)");
  return {
    transform: transform,
    WebkitTransform: transform,
    width: COLUMN_WIDTH,
    height: CELL_HEIGHT
  };
};
var CustomDragLayerComponent = function CustomDragLayerComponent(_ref) {
  var renderItem = _ref.renderItem,
    item = _ref.item,
    isDragging = _ref.isDragging,
    currentOffset = _ref.currentOffset;
  if (!isDragging) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      pointerEvents: 'none',
      zIndex: 1000,
      left: 0,
      top: 0,
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: getItemStyles(currentOffset)
  }, /*#__PURE__*/React.createElement(View, {
    as: "div",
    padding: "x-small",
    background: "secondary",
    shadow: "resting",
    style: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box'
    }
  }, renderItem && item ? renderItem(item) : (item === null || item === void 0 ? void 0 : item.label) || 'Dragging...')));
};
export var CustomDragLayer = DragLayer(function (monitor) {
  return {
    item: monitor.getItem(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  };
})(CustomDragLayerComponent);